<div class="website-content" style="max-width:72rem;padding:0 var(--wa-spacing-x-large) var(--wa-spacing-x-large) var(--wa-spacing-x-large);">
	<div class="wa-stack wa-gap-xl">
		<wa-button [routerLink]="['/plugins']" appearance="plain" variant="neutral">Back to Plugins</wa-button>
		<wa-card appearance="outlined">
			<div class="wa-stack wa-gap-m">
				<div class="wa-stack wa-gap-s">
					<h1 waHeading="xl" waText>AG Grid Enterprise</h1>
					<p waBody="m" waText>Enterprise grid features &mdash; integrated charting, row grouping, server-side row model, pivot tables, range selection, clipboard, Excel export, and status bar, extending the community AG Grid plugin. 8 focused feature modules with &#64;JsonUnwrapped pattern for strongly-typed options.</p>
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="neutral">Java 25+</wa-tag>
						<wa-tag pill variant="neutral">AG Grid Enterprise 35.0.0</wa-tag>
						<wa-tag pill variant="neutral">AG Charts 13.0.0</wa-tag>
						<wa-tag pill variant="neutral">Angular 21</wa-tag>
						<wa-tag pill variant="neutral">JPMS Modular</wa-tag>
						<wa-tag pill variant="warning">License Required</wa-tag>
					</div>
					<p waBody="s" waColorText="warning" waText>AG Grid Enterprise requires a commercial license. 30-day evaluation available from ag-grid.com/license-pricing/</p>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>COORDINATES &amp; MODULE</div>
					<p waBody="s" waText>Maven: com.jwebmp.plugins:aggrid-enterprise</p>
					<p waBody="s" waText>JPMS Module: com.jwebmp.plugins.aggridenterprise</p>
					<p waBody="s" waText>Built on: AG Grid Enterprise 35.0.0</p>
				</div>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>INSTALLATION</div>
					<div class="code-block-wrapper">
						<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Maven</div>
						<markdown [data]="mdContent_55" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
					</div>
					<div class="code-block-wrapper">
						<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Gradle &#40;Kotlin DSL&#41;</div>
						<markdown [data]="mdContent_56" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
					</div>
				</div>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>NPM DEPENDENCIES &#40;auto-included&#41;</div>
					<markdown [data]="mdContent_57" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>FEATURES</div>
					<p waBody="s" waColorText="quiet" waText>Integrated charts &mdash; render charts directly from grid data with configurable themes</p>
					<p waBody="s" waColorText="quiet" waText>Server-side row model &mdash; lazy-load millions of rows with backend pagination</p>
					<p waBody="s" waColorText="quiet" waText>Row grouping &mdash; group by multiple columns, custom hierarchies, expandable groups</p>
					<p waBody="s" waColorText="quiet" waText>Pivot tables &mdash; row and column pivots with value aggregation</p>
					<p waBody="s" waColorText="quiet" waText>Range selection &mdash; select and copy cell ranges, Excel-like behavior</p>
					<p waBody="s" waColorText="quiet" waText>Excel export &mdash; export with styles, formulas, and formatting</p>
					<p waBody="s" waColorText="quiet" waText>Side bar &mdash; columns and filters panels with user toggle</p>
					<p waBody="s" waColorText="quiet" waText>Status bar &mdash; row count, selection count, aggregation metrics</p>
					<p waBody="s" waColorText="quiet" waText>Advanced filtering &mdash; filter builder UI with complex expressions</p>
					<p waBody="s" waColorText="quiet" waText>Row numbers &mdash; official AG Grid row numbering with helper method</p>
					<p waBody="s" waColorText="quiet" waText>AllEnterpriseModule auto-registered via PageConfigurator</p>
					<p waBody="s" waColorText="quiet" waText>8 focused feature modules with &#64;JsonUnwrapped pattern</p>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-m">
					<div waCaption="s" waFontWeight="semibold" waText>EXAMPLES</div>
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>Enterprise Grid Setup</h4>
						<p waBody="s" waColorText="quiet" waText>Set license key and configure enterprise features.</p>
						<markdown [data]="mdContent_58" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
					</div>
				</div>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>QUICK START</div>
					<markdown [data]="mdContent_59" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-s">
					<div waCaption="s" waFontWeight="semibold" waText>SPI EXTENSION POINT DETAILS</div>
					<div class="wa-stack wa-gap-xs">
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="success">IPageConfigurator</wa-tag>
							<wa-tag pill variant="neutral">provides</wa-tag>
						</div>
						<p waBody="s" waColorText="quiet" waText>AgGridEnterprisePageConfigurator auto-registers AllEnterpriseModule, license key, and enterprise CSS/JS</p>
					</div>
				</div>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>SPI EXTENSION POINTS</div>
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="success">provides IPageConfigurator</wa-tag>
					</div>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-s">
					<div waCaption="s" waFontWeight="semibold" waText>CONFIGURATION</div>
					<div class="wa-stack wa-gap-xs">
						<div class="wa-cluster wa-gap-xs">
							<h4 waHeading="s" waText>AG&#95;GRID&#95;LICENSE&#95;KEY</h4>
							<wa-tag pill variant="neutral">String</wa-tag>
						</div>
						<p waBody="s" waColorText="quiet" waText>AG Grid Enterprise license key &mdash; set via AgGridEnterprisePageConfigurator.setAG&#95;GRID&#95;LICENSE&#95;KEY&#40;&#41;</p>
					</div>
				</div>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>PREREQUISITES</div>
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="neutral">Java 25 LTS</wa-tag>
						<wa-tag pill variant="neutral">Maven 3.9+</wa-tag>
						<wa-tag pill variant="neutral">Node.js 18+</wa-tag>
						<wa-tag pill variant="neutral">Angular 21+</wa-tag>
					</div>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-cluster wa-gap-s">
					<wa-tag pill variant="neutral">Upstream: https://www.ag-grid.com/</wa-tag>
					<wa-tag pill variant="neutral">Docs: https://www.ag-grid.com/documentation/</wa-tag>
					<wa-tag pill variant="neutral">Source: https://github.com/JWebMP/AgGridEnterprise</wa-tag>
				</div>
			</div>
		</wa-card>
	</div>
</div>